import {Component, ViewEncapsulation} from '@angular/core';
/**
 * \@title Configurable slider
 */
export class SliderConfigurableExample {
  autoTicks = false;
  disabled = false;
  invert = false;
  max = 100;
  min = 0;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  value = 0;
  vertical = false;
/**
 * @return {?}
 */
get tickInterval(): number | 'auto' {
    return this.showTicks ? (this.autoTicks ? 'auto' : this._tickInterval) : 0;
  }
/**
 * @param {?} v
 * @return {?}
 */
set tickInterval(v) {
    this._tickInterval = Number(v);
  }
private _tickInterval = 1;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slider-configurable-example',
  templateUrl: 'slider-configurable-example.html',
  styleUrls: ['slider-configurable-example.css'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SliderConfigurableExample_tsickle_Closure_declarations() {
/** @type {?} */
SliderConfigurableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SliderConfigurableExample.ctorParameters;
/** @type {?} */
SliderConfigurableExample.prototype.autoTicks;
/** @type {?} */
SliderConfigurableExample.prototype.disabled;
/** @type {?} */
SliderConfigurableExample.prototype.invert;
/** @type {?} */
SliderConfigurableExample.prototype.max;
/** @type {?} */
SliderConfigurableExample.prototype.min;
/** @type {?} */
SliderConfigurableExample.prototype.showTicks;
/** @type {?} */
SliderConfigurableExample.prototype.step;
/** @type {?} */
SliderConfigurableExample.prototype.thumbLabel;
/** @type {?} */
SliderConfigurableExample.prototype.value;
/** @type {?} */
SliderConfigurableExample.prototype.vertical;
/** @type {?} */
SliderConfigurableExample.prototype._tickInterval;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
